"use client";

import React from "react";
import { useTranslation } from "react-i18next";

const PrivacyPolicyPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="p-8 font-sans leading-relaxed max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-center mb-8">
        {t("privacy_policy.title")}
      </h1>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("privacy_policy.introduction_title")}
      </h2>
      <p>{t("privacy_policy.introduction_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("privacy_policy.info_collected_title")}
      </h2>

      <h3 className="text-xl font-semibold mt-4 mb-2">
        {t("privacy_policy.personal_info_title")}
      </h3>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>{t("privacy_policy.personal_info_content")}</li>
      </ul>

      <h3 className="text-xl font-semibold mt-4 mb-2">
        {t("privacy_policy.technical_info_title")}
      </h3>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>{t("privacy_policy.technical_info_content")}</li>
      </ul>

      <h3 className="text-xl font-semibold mt-4 mb-2">
        {t("privacy_policy.usage_data_title")}
      </h3>
      <ul className="list-disc list-inside ml-4 mb-4">
        <li>{t("privacy_policy.usage_data_content")}</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("privacy_policy.how_we_use_title")}
      </h2>
      <ul className="list-disc list-inside ml-4 mb-4">
        {(
          t("privacy_policy.how_we_use_list", {
            returnObjects: true,
          }) as string[]
        )?.map((item: string, index: number) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("privacy_policy.sharing_info_title")}
      </h2>
      <ul className="list-disc list-inside ml-4 mb-4">
        {(
          t("privacy_policy.sharing_info_list", {
            returnObjects: true,
          }) as string[]
        )?.map((item: string, index: number) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("privacy_policy.data_security_title")}
      </h2>
      <p className="mb-4">{t("privacy_policy.data_security_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("privacy_policy.data_retention_title")}
      </h2>
      <p className="mb-4">{t("privacy_policy.data_retention_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("privacy_policy.cookies_title")}
      </h2>
      <p className="mb-4">{t("privacy_policy.cookies_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("privacy_policy.childrens_privacy_title")}
      </h2>
      <p className="mb-4">{t("privacy_policy.childrens_privacy_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("privacy_policy.your_rights_title")}
      </h2>
      <ul className="list-disc list-inside ml-4 mb-2">
        {(
          t("privacy_policy.your_rights_list", {
            returnObjects: true,
          }) as string[]
        )?.map((item: string, index: number) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <p className="mb-4">
        {t("privacy_policy.your_rights_contact")}{" "}
        <a
          href={`mailto:${t("privacy_policy.contact_email")}`}
          className="text-blue-600 hover:underline"
        >
          {t("privacy_policy.contact_email")}
        </a>
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("privacy_policy.policy_changes_title")}
      </h2>
      <p className="mb-4">{t("privacy_policy.policy_changes_content")}</p>

      <h2 className="text-2xl font-semibold mt-6 mb-4">
        {t("privacy_policy.contact_us_title")}
      </h2>
      <p className="mb-2">
        {t("privacy_policy.contact_us_email")}{" "}
        <a
          href={`mailto:${t("privacy_policy.contact_email")}`}
          className="text-blue-600 hover:underline"
        >
          {t("privacy_policy.contact_email")}
        </a>
      </p>
      <p className="mb-4">
        {t("privacy_policy.contact_us_phone")}{" "}
        <a
          href={`tel:${t("privacy_policy.contact_phone_number")}`}
          className="text-blue-600 hover:underline"
        >
          {t("privacy_policy.contact_phone_number")}
        </a>
      </p>
    </div>
  );
};

export default PrivacyPolicyPage;
